<div class="rotate-message-container" fxLayout="column" fxLayoutAlign="center center">
  <h1>Please rotate your device</h1>
  <p>We don't support landscape mode yet.</p>
  <p>Please use portrait mode for the best experience.</p>
</div>
